export default __webpack_public_path__ + "media/music/2b96097806f06e6ee903526530f78c52.mp3";